import { createResource } from "~/lib/resourceFactory";
import { getDepreciationOverview } from "./depreciation-overview.api";

export type DepreciationOverviewParams = { businessId: string };
export type DepreciationOverviewData = Awaited<
  ReturnType<typeof getDepreciationOverview>
>;

export interface DepreciationYearEntry {
  year: number;
  total: number;
  byMethod: Record<string, number>;
}

export const DepreciationOverviewResource = createResource<
  DepreciationOverviewData,
  DepreciationOverviewParams
>({
  key: (p) => ["depreciation-overview", p.businessId] as const,
  fetcher: (p) =>
    getDepreciationOverview({ data: { businessId: p.businessId } }),
  // Avoid suspending SSR when the query is disabled (no active business).
  placeholderData: {
    yearlyDepreciation: [],
    totalFutureDepreciation: 0,
    assetCount: 0,
    skippedCount: 0,
  },
});
